import React from "react";

class ForumContentField extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="form-field">
                <label>
                    <h3>Body</h3>
                    <textarea
                        rows={10}
                        cols={60}
                        value={this.props.value}
                        onChange={this.props.onChange}
                    />
                </label>
            </div>
        )
    }
}

export default ForumContentField;
